// Web Storage can throw on any access: a SecurityError when the browser blocks site data (strict
// Safari privacy settings, some in-app browsers), and a QuotaExceededError on writes when storage is
// full or read-only (older Safari private mode). Persisted values here are conveniences, so a
// blocked read behaves like a missing key and a blocked write is dropped.

type StorageArea = 'localStorage' | 'sessionStorage';

const createSafeStorage = (area: StorageArea) => ({
    get: (key: string): string | null => {
        try {
            return globalThis[area].getItem(key);
        } catch {
            return null;
        }
    },

    /** Returns false when the write was rejected. */
    set: (key: string, value: string): boolean => {
        try {
            globalThis[area].setItem(key, value);
            return true;
        } catch {
            return false;
        }
    },

    remove: (key: string): void => {
        try {
            globalThis[area].removeItem(key);
        } catch {
            // Nothing could have been stored.
        }
    },
});

export const safeLocalStorage = createSafeStorage('localStorage');
export const safeSessionStorage = createSafeStorage('sessionStorage');
